import { useEffect, useState } from 'react';
export const ROSTER_SEARCH_DEBOUNCE_MS = 250;
export function normalizeRosterSearch(value) {
    return value.trim();
}
/**
 * Debounce a server-backed roster search. The caller keeps the immediate input
 * value so typing never waits on the network; this value belongs in the query
 * key and request parameters.
 */
export function useDebouncedRosterSearch(query, delay = ROSTER_SEARCH_DEBOUNCE_MS) {
    const [search, setSearch] = useState(() => normalizeRosterSearch(query));
    useEffect(() => {
        const handle = window.setTimeout(() => {
            setSearch(normalizeRosterSearch(query));
        }, delay);
        return () => window.clearTimeout(handle);
    }, [delay, query]);
    return search;
}
//# sourceMappingURL=search.js.map